<template>
  <div class="mt-3 mb-5">
    <b-spinner v-if="loading" label="Loading reports..." variant="primary" />
    <div v-else-if="tokens.length >= 1" class="mb-3">
      <b-tabs v-if="multipleTabs" v-model="activeTab" @input="onTabChanged">
        <b-tab v-for="(token, index) in tokens" :key="token.embedReportId || index" :title="getTabTitle(token, index)">
          <PowerBIReportDisplay :report-token="token" :is-active="activeTab === index" :tab-index="index" />
        </b-tab>
      </b-tabs>

      <PowerBIReportDisplay
        v-else-if="tokens.length === 1"
        :report-token="tokens[0]"
        :is-active="true"
        :tab-index="0"
      />
    </div>
    <div v-else class="text-muted">No reports available.</div>
  </div>
</template>

<script>
import PowerBIService from '@/shared/services/PowerBIService';
import { mapGetters } from 'vuex';
import { UserGetters } from '@/shared/store/user/types';
import PowerBIReportDisplay from '@/vcp/pages/power-bi-dashboard/PowerBIReportDisplay.vue';

export default {
  name: 'PowerBIReportsPage',
  components: { PowerBIReportDisplay },
  data() {
    return {
      loading: false,
      activeTab: 0,
      tokens: [],
      secondReportTitleByName: {
        EnterpriseVCP: 'Enterprise Dashboard',
        vcp_sales_report: 'Sales Report'
      }
    };
  },
  computed: {
    ...mapGetters({ isAuthenticated: UserGetters.IS_AUTHENTICATED }),
    multipleTabs() {
      return this.tokens.length > 1;
    }
  },
  mounted() {
    this.loadReports();
  },
  methods: {
    async loadReports() {
      if (!this.isAuthenticated) return;
      this.loading = true;
      const tokenData = await PowerBIService.getToken();
      this.tokens = tokenData?.data || [];
      this.loading = false;
    },
    onTabChanged(index) {
      this.activeTab = index;
    },
    getTabTitle(token, index) {
      if (index === 0) return 'VCP Fleet Report';

      return this.secondReportTitleByName[token.reportName] || `Report ${index + 1}`;
    }
  }
};
</script>
